import { Box, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import DetailCalculation from 'module/payroll/global-components/DetailCalculation'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const PaymentDetails = ({ props }) => {
  const { details, time_id } = props
  const navigate = useNavigate()
  const editAdjustment = () => {
    navigate('/app/payroll/regular-payroll/edit', { state: props })
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="calc(100vh - 185px)"
    >
      <Box>
        <DetailCalculation data={details} time_id={time_id} editMtd={true} />
      </Box>
      <Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            my: 1,
            color: 'light-gray-text.main',
          }}
        >
          <Typography>Net pay</Typography>
          <Typography
            variant="subtitle1"
            color={details?.status === 1 ? 'yellow-01.main' : 'dark-text.main'}
          >{`RM ${details?.salary?.nett}`}</Typography>
        </Box>

        <AdxButton variant={'outlined'} sx={{ width: '100%' }} onClick={editAdjustment}>
          Edit adjustment
        </AdxButton>
      </Box>
    </Box>
  )
}

export default PaymentDetails
